import { render, staticRenderFns } from "./PhotoAndVideo.vue?vue&type=template&id=439e542e&scoped=true&"
import script from "./PhotoAndVideo.vue?vue&type=script&lang=js&"
export * from "./PhotoAndVideo.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAndVideo.vue?vue&type=style&index=0&id=439e542e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e542e",
  null
  
)

export default component.exports